"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var PopupText_1 = __importDefault(require("atomicComponents/molecules/Tooltips/PopupText"));
var Money_1 = __importDefault(require("components/Money"));
var general_1 = require("utils/general");
var DoubleCell_1 = __importDefault(require("./components/DoubleCell"));
var utils_1 = require("./utils");
var getMoneyVal = function (value, fallbackText) {
    if ((0, general_1.trueOr0)(value)) {
        return +value;
    }
    return fallbackText ? undefined : 0;
};
var CellContentFactory = function (_a) {
    var item = _a.item, cellConf = _a.cellConf, extractors = _a.extractors, fieldOverrides = _a.fieldOverrides;
    if (cellConf.renderComponent) {
        var Component = cellConf.renderComponent;
        return (0, jsx_runtime_1.jsx)(Component, { item: item });
    }
    if (cellConf.fields) {
        var _b = __read(cellConf.fields
            .map(function (field) { return (0, utils_1.getValue)(item, field, extractors); })
            .map(function (val, idx) { var _a, _b; return ((_a = cellConf.renderFields) === null || _a === void 0 ? void 0 : _a[idx]) ? ((_b = cellConf.renderFields) === null || _b === void 0 ? void 0 : _b[idx])(val) : val; }), 2), mainValue = _b[0], secondaryValue = _b[1];
        var mainFieldOverride = fieldOverrides === null || fieldOverrides === void 0 ? void 0 : fieldOverrides[cellConf.fields[0]];
        var mainContent = (mainValue || cellConf.fallback) && (0, jsx_runtime_1.jsx)(PopupText_1.default, { message: mainValue !== null && mainValue !== void 0 ? mainValue : cellConf.fallback, placement: "top" });
        if (mainFieldOverride === null || mainFieldOverride === void 0 ? void 0 : mainFieldOverride.money) {
            var fallbackText = mainFieldOverride.money.fallbackText || cellConf.fallback;
            var moneyVal = getMoneyVal(mainValue, fallbackText);
            mainContent = (0, jsx_runtime_1.jsx)(Money_1.default, __assign({}, cellConf.money, { fallbackText: fallbackText, amount: moneyVal }));
        }
        return ((0, jsx_runtime_1.jsx)(DoubleCell_1.default, { main: mainContent, secondary: secondaryValue && (0, jsx_runtime_1.jsx)(PopupText_1.default, { message: secondaryValue }) }));
    }
    if (!cellConf.field) {
        return null;
    }
    var value = (0, utils_1.getValue)(item, cellConf.field, extractors);
    var stringVal = cellConf.renderField ? cellConf.renderField(value) : value;
    if (cellConf.money) {
        var fallbackText = cellConf.money.fallbackText || cellConf.fallback;
        var moneyVal = getMoneyVal(value, fallbackText);
        return ((0, jsx_runtime_1.jsx)(Money_1.default, __assign({}, cellConf.money, { fallbackText: fallbackText, amount: moneyVal })));
    }
    if (cellConf.truncate) {
        return (0, jsx_runtime_1.jsx)(PopupText_1.default, __assign({}, cellConf.truncate, { message: stringVal }));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: stringVal !== null && stringVal !== void 0 ? stringVal : cellConf.fallback });
};
exports.default = (0, utils_1.typedMemo)(CellContentFactory);
